import React from "react"
import SeminarTypes from "./seminar-types"
import SeminarStatus from "./seminar-status"
import LazyAndPreloadImage from "../../functions/lazy_and_preload_image"
import { Link } from "gatsby"

export default function SeminarList({ data }) {
  return (
    <>
    {
      data ?
      <div className="grid_wrap">
        {data.map(({ node }) => (
          <div className="grid_contents" key={node.seminarsId}>
            <SeminarStatus status={node.status} />
            <Link to={'/seminar/' + node.seminarsId}>
              <div className="contents_box">
                <LazyAndPreloadImage imgUrl={node.image ? node.image.url : ''} alt="セミナー一覧" width="650" height="365" />
              </div>
              <SeminarTypes types={node.types} />
              <div className="seminar_title">{node.title}</div>
              <div className="data">開催日程：{node.display_event_date}</div>
              <div className="seminar_tag">
                {node.tags.map((tag) => (
                  tag.type[0] === "セミナータグ" ?
                    <p key={tag.id}>#{tag.name}</p>
                  : ''
                ))}
              </div>
            </Link>
          </div>
        ))}
      </div>
      :

      <div className="empty_contents">
        現在、受付中または開催中のセミナーはありません。次の開催までしばしお待ち下さい。
      </div>
    }
    </>
  )
}
